module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGZpbGw9IiMwN2EwYmIiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTguMTUxIDIwLjU0NmwtNy44LTcuOGExLjIgMS4yIDAgMCAxIDAtMS42OTdMMi4wNDggOS4zNWExLjIgMS4yIDAgMCAxIDEuNjk4IDBMOSAxNC42MDYgMjAuMjU0IDMuMzVhMS4yIDEuMiAwIDAgMSAxLjY5OCAwbDEuNjk3IDEuNjk4YTEuMiAxLjIgMCAwIDEgMCAxLjY5N2wtMTMuOCAxMy44YTEuMiAxLjIgMCAwIDEtMS42OTggMHoiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/socials/share/check.svg
// module id = u4RL
// module chunks = 0